import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { message, Switch, Select, Form, Input, Row, Col, DatePicker, Upload, Space, Button } from 'antd';
import Modal from 'react-bootstrap/Modal';
import { app } from '../../config';
import getHeaders from '../../utils/authHeaders';
import TextArea from 'antd/lib/input/TextArea';
import { AddRecord } from '../../layouts/AddRecord';
import { InputField, SelectField, TextAreaField } from '../../layouts/FormFields';
import TagInput from '../Products/TagInput';
import { InfoCircleOutlined, LoadingOutlined, UploadOutlined } from '@ant-design/icons';
import getSampleVideoType from '../../hooks/getSampleVideoType';
import AddPhoto from '../../assets/images/add.png';
import TestComponent from '../Products/TestComponent';
import { MdError } from 'react-icons/md';
import { BiSolidError } from 'react-icons/bi';
import getAllProductCategories from '../../hooks/getAllProductCategories';
import TagSelect from '../Products/TagSelect';
import moment from 'moment';

const AddSubscription = () => {
  const { t } = useTranslation(['common']);
  const [addUserResp, setAddUserResp] = useState({});
  const [show, setShow] = useState(false);
  const [uploadedImg, setUploadedImg] = useState('');
    const [imageuploading, setImageUploading] = useState(false);
    const [imgError, setImgError] = useState(false);
      const [categoryId, setcategoryId] = useState();
  const [productsdata, setproductsdata] = useState([])
  const [durationdata, setdurationdata] = useState([]);
  const [frequencydata, setfrequencydata] = useState([]);
  const [durationId, setdurationId] = useState();

const [facialScandata, setfacialScandata] = useState([]);
  
  const[isActive,setisActive]=useState(true)
  const [largeFile, setLargeFile] = useState(false);
  const productCategoriesRes = getAllProductCategories();
  const [productCat, setProductCat] = useState([]);

  const [loading, setLoading] = useState(false);
  const [isDisabled, setisDisabled] = useState(false);

  const [tags, setTags] = useState([]);
  const [uploadVideo, setuploadVideo] = useState('');
  const [contentType, setContentType] = useState();
  const [uplVid, setuplVid] = useState(true);
  const sampleVideoRes = getSampleVideoType();
    const [prodDescription, setProdDescription] = useState('');
  const productCategories = productCategoriesRes.response ? productCategoriesRes.response.data : [];
  
  // const [imageuploading, setimageuploading] = useState(false);
  // const [uploadImage, setuploadImage] = useState('');

  let header = getHeaders();

  const sampleVideo = sampleVideoRes.response ? sampleVideoRes.response : [];
  console.log(sampleVideo);

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    // reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };
   const beforeUpload = (file) => {
     console.log(file);
     if (file) {
       const img = new Image();
       img.src = URL.createObjectURL(file);
       img.onload = () => {
           if (img.width < 700 || img.width > 1100 || img.height < 1100 || img.height > 2000) {
             setImgError(true);
             return null;
           } else {
             setImgError(false);

             if (file.type === 'image/jpeg' || file.type === 'image/png') {
               console.log('setting image type');
               setContentType('img');
             } else if (file.type === 'video/x-matroska' || file.type === 'video/mp4') setContentType('video');
             const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'video/x-matroska' || file.type === 'video/mp4';
             if (!isJpgOrPng) {
               message.error('You can only upload JPG/PNG file!');
             }
             console.log('file Checked');
             const isLt2M = file.size / 1024 / 1024 < file.type === 'video/mp4' ? 200 : 20;
             if (!isLt2M) {
               setLargeFile(true);
               message.error('Image must smaller than 20MB!');
             }
             console.log('message');
             return isJpgOrPng && isLt2M;
           }
       };
     }
   };
 const handleChange = (info) => {
   if (info.file.status === 'uploading') {
     console.log('uploading data');
     if (!imgError) {
       setUploadedImg('');
       setImageUploading(true);
       setLoading(true);
       return;
     } else {
       setImageUploading(false);
       setLoading(false);
       return;
     }
   }
   if (info.file.status === 'done' && !imgError) {
     // Get this url from response in real world.
     setLargeFile(false);
     console.log(info.file.response);
     info.file ? console.log(info.file.response.result.data.Location) : console.log('Not found');
     info.file ? setUploadedImg(info.file.response.result.data.Location) : ' ';
     info.file ? setImageUploading(false) : ' ';

     getBase64(info.file.originFileObj, (url) => {
       setLoading(false);
       setImageUploading(false);
      //  setuploadLogo(false);
     });
   }
  };
  const getproductsusingCategoryId = async (id) => {
    try {
            // const res = await axios.get(`http://192.168.100.16:3200/api/v1/admin/product/getproducts?productCategoryId=${id}`, { headers: getHeaders() });
      
      const res = await axios.get(`${app.URL}/api/v1/admin/product/getproducts?productCategoryId=${id}`, { headers: getHeaders() });

      console.log("response", res.data.result.data)
      if (res.status == 200) {
        setproductsdata(res.data.result.data);
      }
     
      
    } catch (error) {
      console.log(error)
      return
    }
    
  }
   const getdurations = async (id) => {
     try {
      //  const res = await axios.get(`${app.URL}/api/v1/admin/product/getproducts?productCategoryId=${id}`, { headers: getHeaders() });
       const res = await axios.get(`${app.URL}/api/v1/admin/duration/get`, { headers: getHeaders() });

       console.log('response2', res);
       if (res.status == 200) {
         setdurationdata(res.data.result.data);
       }
     } catch (error) {
       console.log(error);
       return;
     }
  };
    const getfacialPackages = async (id) => {
      try {
        const res = await axios.get(`${app.URL}/api/v1/admin/facialpackages/view`, { headers: getHeaders() });
        // const res = await axios.get(`http://192.168.100.16:3200/api/v1/admin/facialpackages/view`, { headers: getHeaders() });

        console.log('response2', res);
        if (res.status == 200) {
          // let disarr = [...res.data.result.data];
          // disarr.push({})
          setfacialScandata(res.data.result.data);
        }
      } catch (error) {
        console.log(error);
        return;
      }
    };
   useEffect(() => {
     getdurations()
     getfacialPackages()
   }, []);
  useEffect(() => {
    if (categoryId) {
      getproductsusingCategoryId(categoryId);
    }
  }, [categoryId]);
  console.log(uploadVideo);
  let navigate = useNavigate();
  const [uploadObj, setUploadObj] = useState({});
  function goBack() {
    navigate('/subscribe/list', { replace: true });
  }
  window.addEventListener('popstate', goBack);

  const user = JSON.parse(localStorage.getItem('user'));

  const uploadData = async (userDetails) => {
    console.log("isdsiabe", isDisabled)
    // return
    setLoading(true);
    let userId = user?.result.data.user.userId;
    userDetails.userId = userId;
    console.log(userDetails);

    try {
      const res = await axios.post(`${app.URL}/api/v1/admin/subscribe/create`, userDetails, { headers: getHeaders() });
      // const res = await axios.post(`http://192.168.100.16:3200/api/v1/admin/subscribe/create`, userDetails, { headers: getHeaders() });

      // const res = await axios.post(`http://192.168.100.25:3200/api/v1/admin/subscribe/create`, userDetails, { headers: getHeaders() });
      setLoading(false);
      setShow(false);
      console.log('Response', res);
      if (res.data.success) {
        console.log('Success');
        setAddUserResp(res.data.data);
        setTimeout(goBack, 500);

        message.success(res.data.msg);

      } else if (!res.data.success) {
        message.warning(res.data.msg);
        setisDisabled(false)
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      setShow(false);
        setisDisabled(false);

      if (err) console.log(err.response.data.message);
      else return;
    }
  };
console.log("Response", addUserResp)
  // const onFinish = (values) => {
  //   console.log(values, 'values');
  //   // return;
  //   const payload = {
  //     ...values,
  //     image: uploadedImg ? uploadedImg : '',
  //     description: prodDescription,
  //     patientId: null,
  //     type: 'system',
  //   };
  //   console.log(payload, 'payload');
  //   // return;
  //   if (Object.keys(payload).length > 0) {
  //     uploadData(payload);
  //   }
  // };;
  
  const onFinish = (values) => {


  
    console.log(values, 'values',productCat);
    // return;
 if (productCat.length == 0) {
   message.error('Select atleast one product');
   return;
 }
    const payload = {
      ...values,
      startDate: values.startDate ? values.startDate.format().split('T')[0] : '',
      endDate: values.endDate ? values.endDate.format().split('T')[0] : '',
      image: uploadedImg ? uploadedImg : '',
      description: prodDescription,
      productId: productCat,
      // productCategoryId:category,
      facialPackageId: values?.facialPackageId ? values.facialPackageId : null,
      patientId: null,
      type: 'system',
      quantity: values?.quantity ? Number(values.quantity) : 1,
    };
    setisDisabled(true);
    // return;

    // setUploadObj(payload);
    // setShow(true);
    //  if (Object.keys(payload).length > 0) {
     uploadData(payload);
  //  }
    console.log(payload, 'payload');
    return;
  };
  const submitData = () => {
   return
  };

   const handleKeyPress = (e) => {
     console.log(e);
     let test = false;

     console.log(e.charCode);
     const keyCode = e.which || e.keyCode;
     // && e.target.value.length<1
     if (e.charCode === 32) {
       console.log('Space key pressed');
       // 32 is the charCode for space key
       e.preventDefault(); // Prevent the default behavior (typing space)
     }
     // Block alphabetic characters (A-Z and a-z)  ((e.charCode >= 65 && e.charCode <= 90) || (e.charCode >= 97 && e.charCode <= 122))
     if (e.charCode >= 58 && e.charCode !== 46) {
       e.preventDefault();
     } else if (e.charCode <= 47 && e.charCode !== 46) {
       e.preventDefault();
     }
   };

      const getFrequency = async () => {
        try {
          //  const res = await axios.get(`${app.URL}/api/v1/admin/product/getproducts?productCategoryId=${id}`, { headers: getHeaders() });
          // const res = await axios.get(`http://192.168.100.18:3200/api/v1/admin/duration/get?type=frequency&durationId=${durationId}`, { headers: getHeaders() });
          const res = await axios.get(`${app.URL}/api/v1/admin/duration/get?type=frequency&durationId=${durationId}`, { headers: getHeaders() });

          console.log('response2', res);
          if (res.status == 200) {
            setfrequencydata(res.data.result.data);
          }
        } catch (error) {
          console.log(error);
          return;
        }
      };
  useEffect(() => {
    if (durationId) {
    getFrequency()
  }
},[durationId])
  
  const handleClose = () => setShow(false);
  const onFinishFailed = (errorInfo) => {
    console.log('Img', uploadedImg);
    console.log('Failed:', errorInfo);
  };

  const [videoNote, showVideoNote] = useState(false);

  const boxToggleVideo = () => {
    setuploadVideo('');
  };

  // const handleuploadImage = (info) => {
  //   if (info.file.status === 'uploading') {
  //     setimageuploading(true);
  //   }
  //   if (info.file.status === 'done') {
  //     // Get this url from response in real world.
  //     info.file ? console.log(info.file.response.result.data.Location) : console.log('Not found');
  //     info.file ? setuploadImage(info.file.response.result.data.Location) : ' ';
  //     setimageuploading(false);
  //   }
  // };
   const handleProductDescription = (htmlContent) => {
     setProdDescription(htmlContent);
   };


  return (
    <AddRecord
      // videoUrl={uploadVideo}
      loading={loading}
      pageTitle='Add Subscription'
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      handleClose={handleClose}
      show={show}
      addUserResp={addUserResp}
      goBack={goBack}
      // disable={true}
      disable={isDisabled}
      initialValues={{
        remember: true,
        // ['isActive']: true,
        // ['verificationCount']: 2,

        // ['boxIngredients']: [],
        // ['boxIngredient']: [{ boxName: 'box 1' }, { boxName: 'box 1' }, { boxName: 'box 1' }],
      }}
      inputs={[
        <InputField
          label='Name'
          name='name'
          col='col-lg-4 col-md-4 col-6'
          required={true}
          placeholder='Name'
          rules={[
            {
              required: true,
              message: 'Enter Name',
            },
          ]}
        />,
        <SelectField
          label='Duration'
          name='duration'
          col='col-lg-3 col-md-3 col-6'
          required={true}
          placeholder='Duration'
          options={durationdata?.map((item) => (
            <Select.Option value={item.id}>{item.name}</Select.Option>
          ))}
          rules={[
            {
              required: true,
              message: 'Select Duration',
            },
          ]}
          onChange={(e) => setdurationId(e)}
        />,
        <SelectField
          label='Frequency'
          name='frequency'
          col='col-lg-3 col-md-3 col-6'
          required={true}
          placeholder='Frequency'
          options={frequencydata?.map((item) => (
            <Select.Option value={item.frequencyId}>{item.frequency}</Select.Option>
          ))}
          rules={[
            {
              required: true,
              message: 'Select Frequency',
            },
          ]}
        />,
        <InputField
          col='col-lg-2 col-md-3 col-12'
          name='amount'
          label='Amount'
          rules={[
            {
              required: true,
              message: 'Amount',
            },
          ]}
          placeholder='Enter Amount'
          required={true}
          onKeyPress={handleKeyPress}
          // onkeydown={handleKeyPress}
          onChange={handleKeyPress}
        />,
        // <InputField
        //   label='No. of Steps'
        //   name='noOfSteps'
        //   col='col-lg-2 col-md-3 col-6'
        //   required={true}
        //   placeholder='No. of Steps'
        //   rules={[
        //     {
        //       required: true,
        //       message: 'Enter No. of Steps',
        //     },
        //   ]}
        // />,

        <SelectField
          label='Category'
          name='productCategoryId'
          col='col-lg-4 col-md-3 col-6'
          required={true}
          placeholder='Product Category'
          options={productCategories?.map((item) => (
            <Select.Option value={item.productCategoryId}>{item.name}</Select.Option>
          ))}
          rules={[
            {
              required: true,
              message: 'Select Product Category',
            },
          ]}
          onChange={(e) => {
            setcategoryId(e);
            setProductCat([]);
          }}
        />,
        <div className='col-md-6 col-12'>
          <TagSelect
            // options={productCategories.map((item) => {
            //   if (!productCat.includes(item.productCategoryId)) {
            //     return <Select.Option value={item.productCategoryId}>{item.name}</Select.Option>;
            //   }
            // })}
            tags={productCat}
            setTags={setProductCat}
            options={productsdata?.map((item) => (
              <Select.Option value={item.productId}>{item.name}</Select.Option>
            ))}
            label='Product'
            cisPanelCode={productsdata}
            isSubscrip={true}
            // setcisPanelCode={setproductsdata}
          />
        </div>,
        <InputField
          col='col-lg-2 col-md-3 col-12'
          name='quantity'
          label={<span style={{ whiteSpace: 'nowrap' }}>Quantity Per Frequency</span>}
          // rules={[
          //   {
          //     required: true,
          //     message: 'Enter Quantity',
          //   },
          // ]}
          placeholder='Enter Quantity'
          // required={true}
          onKeyPress={handleKeyPress}
          // onkeydown={handleKeyPress}
          defaultValue={1}
          onChange={handleKeyPress}
        />,

        // <div className='col-md-6 col-12'>
        <SelectField
          name='facialPackageId'
          label='Facial Scan'
          rules={[
            {
              required: false,
              message: 'Facial Scan',
            },
          ]}
          allowClear
          placeholder='Facial Scan'
          col='col-lg-4 col-md-5 col-6'
          required={false}
          options={facialScandata?.map((item) => (
            <Select.Option value={item.facialPackageId}>
              {item.name} ({item.scans} scans for ${item.pricing})
            </Select.Option>
          ))}
        />,
        <InputField
          col='col-lg-3 col-md-3 col-12'
          name='facialValidity'
          label={<span style={{ whiteSpace: 'nowrap' }}>Facial Validity</span>}
          // rules={[
          //   {
          //     required: true,
          //     message: 'Enter Quantity',
          //   },
          // ]}
          placeholder='Enter validity in days'
          // required={true}
          onKeyPress={handleKeyPress}
          // onkeydown={handleKeyPress}
          // defaultValue={1}
          onChange={handleKeyPress}
        />,
        // </div>,

        <div className='col-8 mb-4'>
          <TestComponent title='Description' textvalue={prodDescription} onChange={handleProductDescription} />
        </div>,
        <div className='row'>
          <div className=' col-md-3 media-column mb-3'>
            <label>Image</label>
            <Upload listType='picture-card' className='avatar-uploader ' showUploadList={false} action={`${app.URL}/api/v1/general/product/logoUpload`} beforeUpload={beforeUpload} onChange={handleChange} headers={header}>
              {uploadedImg && !imageuploading ? (
                <img className='added-img' src={uploadedImg} alt='avatar' />
              ) : !uploadedImg && imageuploading ? (
                <LoadingOutlined style={{ fontSize: '40px' }} />
              ) : (
                <div className='d-flex flex-column py-3'>
                  <img className='for-add-img' src={AddPhoto} alt='avatar' />
                  <p className='add-text'>Upload Image</p>
                </div>
              )}
            </Upload>

            <div className='d-flex align-items-center gap-2'>
              {imgError ? <BiSolidError size={16} color='red' /> : !uploadedImg && !imageuploading && <MdError size={16} color='#f2b544' />}
              <p style={{ fontSize: '14px' }}>{imgError ? 'The image is not between 700-1100 x 1100-2000 px.' : !uploadedImg && !imageuploading && 'Note: Upload image size 2MB with 700-1100 x 1100-2000 px.'}</p>
            </div>
            {uploadedImg && (
              <>
                <button
                  style={{ backgroundColor: '#F21D2F' }}
                  onClick={() => {
                    setUploadedImg('');
                    setImgError(false);
                  }}
                  className='add-btn'
                >
                  Remove
                </button>
                <br />
                {/* <p>{uploadedImg ? uploadedImg : null}</p> */}
                {/* <input type='text' value={uploadedImg || ''} readOnly /> */}
              </>
            )}

            {/* <small className='mt-2 font-weight-light' style={{ fontSize: '14px' }}>
                           Note: Upload max image size 2MB with 1100 x 2000 px.
                         </small> */}
          </div>
        </div>,
      ]}
      submitData={submitData}
      switchBtn={false}
      setisActiv={setisActive}
      isCalen={true}
      addMessage='Are you sure you want to add Subscription?'
    />
  );
};

export default AddSubscription;
